// extracted by mini-css-extract-plugin
export default {"container":"wZ-z","title":"xZ-z","link":"yZ-z"};